import React from "react";
import styles from "./FeatureCard.module.scss";
import { ArrowUpright } from "../../../../assets/icons";

interface FeatureCardProps {
	icon: React.ReactNode;
	title: React.ReactNode;
	description: string;
	image: string;
	type: "solar" | "bills" | "energy" | "request" | string;
    link : string;
}

const FeatureCard = ({ icon, title, description, image, type, link }: FeatureCardProps) => {
	const getIconClass = () => {
		if (type === "solar") return styles.solarIcon;
		if (type === "bills") return styles.billsIcon;
		if (type === "energy") return styles.energyIcon;
		return styles.serviceIcon;
	};

	const getCardClass = () => {
		const baseClass = styles.card;
		if (type === "solar") return `${baseClass} ${styles.solarCard}`;
		if (type === "bills") return `${baseClass} ${styles.billsCard}`;
		if (type === "energy") return `${baseClass} ${styles.energyCard}`;
		return `${baseClass} ${styles.serviceCard}`;
	};

	return (
		<a href={link} className={getCardClass()}>
			<div className={styles.header}>
				<div className={styles.innerHead}>
					<div className={`${styles.iconContainer} ${getIconClass()}`}>{icon}</div>
                    <div className={styles.blackCircle}>
                        <ArrowUpright />
                    </div>
				</div>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.description}>{description}</p>
			</div>

			<div className={styles.imageContainer}>
				<img src={image} alt={`${type} module illustration`} className={styles.image} />
			</div>
		</a>
	);
};

export default FeatureCard;